import React from 'react';
import axios from 'axios';
import { lawsAPIToken } from '~api/laws';
import { withRouter } from 'react-router-dom';
import { withNamespaces, Trans } from 'react-i18next';
import Input from '~components/input';
import LoadingButton from '~components/loading-button';
import { iconBackBtn } from '~utils/svgIcons';
import { toast } from 'react-toastify';
import { ErrorMessage } from '~components/toast';
import validate from 'validate.js';
import validationRules from '~utils/validator';
import '~routes/login-page/style.scss';
import './style.scss';

function ResetForm({ isMobile, backCallback }) {
    const [state, setState] = React.useState({
        email: {
            value: '',
            isInvalid: false,
            error: <Trans i18nKey="validationRules.required-message" />,
        },
    });

    const [captchaToken, setCaptchaToken] = React.useState('');
    const [sended, setSended] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);

    const onChangeHandler = React.useCallback(
        (event) => {
            setState({
                ...state,
                [event.target.name]: {
                    value: event.target.value.trim(),
                    isInvalid: false,
                    error: '',
                },
            });
        },
        [state]
    );

    const onFormSubmit = React.useCallback(async (event) => {
        event.preventDefault();

        if (!state.email.value) {
            setState({
                email: {
                    value: '',
                    isInvalid: true,
                    error: <Trans i18nKey="validationRules.required-message" />,
                },
            });
        }

        // Валидируем все данные формы перед отправкой:
        let validatedData = {};
        const validatorAnswer = validate(
            {
                email: state.email.value,
            },
            {
                email: validationRules.email,
            }
        );

        const isValid = typeof validatorAnswer === 'undefined';

        if (!isValid) {
            const { email } = validatorAnswer;
            validatedData = {
                email: {
                    value: state.email.value,
                    isInvalid: Boolean(email),
                    error: email ? validatorAnswer.email[0] : '',
                },
            };
            setState(validatedData);
            return;
        }

        if (window.grecaptcha && !captchaToken) {
            toast(<ErrorMessage message="Подтвердите, что вы не робот" />);
            return;
        }

        setLoading(true);

        lawsAPIToken()
            .post('/users/send_password_recovery_email/', { captcha_response: captchaToken, email: state.email.value  })
            .then(() => {
                setLoading(false);
                setSended(true)
            })
            .catch((error) => {
                if (!axios.isCancel(error)) {
                    toast(<ErrorMessage message={error.message} />);
                }
                setLoading(false);
            });
    }, [state, captchaToken]);

    const captchaSuccess = React.useCallback((data) => {
        setCaptchaToken(data);
    }, []);

    React.useEffect(() => {
        if (Boolean(window.grecaptcha) === false) {
            console.warn('recaptcha не инициализирована');
        }
        window.grecaptcha && window.grecaptcha.render('gcaptcha', {
            theme: 'light',
            size: 'normal',
            callback: captchaSuccess,
            sitekey: '6LcoRd0cAAAAAAv52_pxqj2AcG4aMHfYnQ-VgOnI',
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { email } = state;

    return (
        <form className="reset-form">
            <button type="button" className="reset-form__back-button" onClick={backCallback}>
                {iconBackBtn}
            </button>
            {sended ? (
                <h3 className="login-page__header">На указанную почту отправлена ссылка смены пароля</h3>
            ) : (
                <React.Fragment>
                    <h3 className="login-page__header">Восстановление пароля</h3>
                    <Input
                        type="email"
                        placeholder="E-mail"
                        name="email"
                        onChange={onChangeHandler}
                        value={email.value}
                        isError={email.isInvalid}
                        message={email.error}
                    />
                    <div className="g-recaptcha reset-form__recaptcha" id="gcaptcha"></div>
                    <LoadingButton
                        type="submit"
                        size={isMobile ? 'small' : 'big'}
                        onClick={onFormSubmit}
                        isMobile={isMobile}
                        ariaLabel="Восстановить пароль"
                        isLoading={isLoading}
                        disabled={isLoading}
                    >
                        Восстановить пароль
                    </LoadingButton>
                </React.Fragment>
            )}
        </form>
    );
}

export default withRouter(withNamespaces('translation')(ResetForm));



// WEBPACK FOOTER //
// ./src/routes/login-page/login/reset-password-form/index.js